/**
 * @file
 * Robust Teaser component behavior.
 *
 * Adjusts Swiper spacing for gallery within robust-teaser.
 *
 * @param {object} Drupal - The Drupal object.
 * @param {Function} once - The once function.
 */

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.robustTeaserGalleryBehavior = {
    attach: function (context) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      once('robust-teaser-gallery', '.robust-teaser .gallery > .swiper', context).forEach((gallery) => {
        if (gallery.swiper) {
          gallery.swiper.params.spaceBetween = 8;
          gallery.swiper.params.speed = prefersReducedMotion ? 0 : 300;
          gallery.swiper.update();
          gallery.querySelectorAll('.gallery-slide__media-wrapper').forEach((wrapper) => {
            wrapper.setAttribute('tabindex', '0');
          });
        }
      });
    }
  };
})(Drupal, once);
